import { render, staticRenderFns } from "./SecureLink.vue?vue&type=template&id=496aa80c&"
import script from "./SecureLink.vue?vue&type=script&lang=js&"
export * from "./SecureLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496aa80c')) {
      api.createRecord('496aa80c', component.options)
    } else {
      api.reload('496aa80c', component.options)
    }
    module.hot.accept("./SecureLink.vue?vue&type=template&id=496aa80c&", function () {
      api.rerender('496aa80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Recipients/SecureLink.vue"
export default component.exports